module.exports = "/fast-coin/img/coin/anim/out_2/out_2_002.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_2/out_2_002.png
// module id = 2308
// module chunks = 5